import Vue from 'vue'
import App from './App'
import {
  ADD_LANGUAGE,
  CONFIG_FETCH_FAILED,
  CONFIG_FETCH_SUCCESS,
  LOGGED_IN,
  SAVE_SESSION_EXPIRED_ACTION,
  SET_INFORMATION_SNACKBAR_STATE,
  SET_INFORMATION_SNACKBAR_TEXT
} from './store/mutation-types'
import router from './router'
import store from './store'
import axios from 'axios'
import Vuetify from 'vuetify'
import vuexI18n from 'vuex-i18n'
import translationsDefault from '../static/translations/default.json'
import server from './store/server'
import {
  GET_DROPDOWN_VALUES,
  REFRESH_LOGIN,
  FETCH_USER_ANNOUNCEMENTS,
  GET_TUTOR_BOOLEAN,
  APPLY_SESSION_EXPIRED_ACTIONS,
  GET_CHART_LIMIT_BOOLEAN, GET_ENGAGEMENT_LAST_SUCCESSFUL
} from './store/action-types'
import { informationTexts } from './store/modules/information'
import { messageBus } from './MessageBus'

import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'

import('mdi/css/materialdesignicons.min.css')
import('./main.css')

Vue.use(vuexI18n.plugin, store)
Vue.i18n.add('default', translationsDefault)

Vue.use(VCalendar, {
  // OPTIONAL: Pass default settings here (default values shown below)
  componentPrefix: 'v',
  firstDayOfWeek: 1, // Sunday is the default
  navVisibility: 'focus',
  titlePosition: 'center',
  titleTransition: 'slide-h', // Horizontal slide
  weeksTransition: 'slide-h',
  dateFormatter: d => d.toLocaleDateString(),
  dateParser: s => new Date(Date.parse(s)),
  datePickerInputClass: '',
  datePickerInputStyle: null,
  datePickerInputPlaceholder: '',
  datePickerSelectColor: '#66B3CC',
  datePickerDragColor: '#9FCFDF', // Only used for drag mode
  datePickerShowCaps: false, // Only used for drag mode
  datePickerShowPopover: true,
  popoverExpanded: false,
  popoverDirection: 'bottom',
  popoverAlign: 'left',
  popoverVisibility: 'hover',
  popoverContentOffset: '10px',
  maxSwipeTime: 300, // ms
  minHorizontalSwipeDistance: 60, // px
  maxVerticalSwipeDistance: 80, // px
  maxTapTolerance: 0, // ms
  maxTapDuration: 200, // ms
  highlight: {
    animated: true,
    height: '1.8rem',
    borderWidth: '0',
    borderStyle: 'solid',
    borderRadius: '290486px',
    opacity: 1
  },
  highlightCaps: {
    animated: true,
    height: '1.9rem',
    borderWidth: '0',
    borderStyle: 'solid',
    borderRadius: '290486px',
    opacity: 1
  },
  dot: {
    diameter: '5px',
    backgroundColor: '#66b3cc',
    borderWidth: '0',
    borderStyle: 'solid',
    borderRadius: '50%',
    opacity: 1
  },
  bar: {
    height: '3px',
    backgroundColor: '#66b3cc',
    borderWidth: '0',
    borderStyle: 'solid',
    opacity: 1
  },
  themeStyles: {
    wrapper: {backgroundColor: '#fafafa', border: '1px solid #dadada'},
    verticalDivider: {borderLeft: '1px solid #dadada'},
    header: {backgroundColor: '#ffffff'},
    // headerTitle: null,
    // headerArrows: null,
    // headerVerticalDivider: null,
    // headerHorizontalDivider: null,
    // weekdays: null,
    // weekdaysVerticalDivider: null,
    // weekdaysHorizontalDivider: null,
    // weeks: null,
    // weeksVerticalDivider: null,
    // dayCell: null,
    dayCellNotInMonth: {opacity: 0.4},
    // dayContent: null,
    // dayContentHover: null,
    // dots: null,
    // bars: null,
    dayPopoverContent: {
      color: '#333333',
      fontSize: '.8rem',
      whiteSpace: 'nowrap'
    }
  }
})

const originalLineDraw = window.Chart.controllers.line.prototype.draw
const alertImg = new Image()
alertImg.src = '/static/icons/alarm.svg'
const interventionImg = new Image()
interventionImg.src = '/static/icons/account-multiple.svg'
const courseChangeImg = new Image()
courseChangeImg.src = '/static/icons/compare_arrows.svg'

const interactionIcons = {
  INTERVENTION: interventionImg,
  ALERT: alertImg,
  COURSE_CHANGE: courseChangeImg
}

window.Chart.helpers.extend(window.Chart.controllers.line.prototype, {
  draw: function () {
    const chart = this.chart
    const ctx = chart.chart.ctx
    const xAxis = chart.scales['x-axis-0']
    const yAxis = chart.scales['y-axis-0']
    const interactions = chart.config.data.interactions
    const iconHeight = 24
    const padding = 6

    // Allow graph specific drawing
    if (chart.options.extraDraw) {
      chart.options.extraDraw(ctx, chart, xAxis, yAxis)
    }

    if (interactions !== undefined) {
      interactions.forEach((interaction) => {
        const date = interaction.date
        const length = interaction.list.length
        interaction.list.forEach((item, idx, array) => {
          const axisX = xAxis.getPixelForValue(Number(date))
          const iconX = axisX - 12
          ctx.beginPath()
          ctx.strokeStyle = '#9c27b0'
          ctx.lineWidth = 2
          ctx.moveTo(axisX, yAxis.top + padding * (idx) + iconHeight * (idx))
          ctx.lineTo(axisX, yAxis.top + padding * (idx + 1) + iconHeight * (idx))
          ctx.drawImage(interactionIcons[item.type], iconX, yAxis.top + iconHeight * idx + (padding * (idx + 1)))
          // TODO add canvas coordinates to a map so we can add an event listener for clicking.
          // ctx.lineTo(xAxis.getPixelForValue(xCoordinate), yAxis.top + 51)
          // ctx.moveTo(xAxis.getPixelForValue(xCoordinate), yAxis.top + 40)
          // ctx.lineTo(xAxis.getPixelForValue(date), yAxis.height / 2)
          // const text = 'Intervention'
          // const width = ctx.measureText(text).width
          // ctx.fillStyle = '#000000'

          if (idx === length - 1) {
            ctx.moveTo(axisX, yAxis.top + padding * (idx + 1) + iconHeight * (idx + 1))
            ctx.lineTo(axisX, yAxis.bottom)
          }
          ctx.stroke()
        })
      })
    }
    originalLineDraw.apply(this, arguments)
  }
})

// Setup default axios responses to error codes
axios.interceptors.response.use(
  (res) => {
    store.dispatch(REFRESH_LOGIN, res)
    return res
  },
  (error) => {
    if (
      // ERR_CONNECTION_REFUSED
      (error.status === undefined && JSON.stringify(error.request) === '{}' && !error.response) ||
      // 500 (Internal Server Error)
      (error.response.status === 500 && error.response.data.exception.includes('DataAccessResourceFailureException')) ||
      // 503 (Service Unavailable)
      (error.response.status === 503)) {
      router.push('/error')
    }

    // If we have SAML authentication we need to refresh the page on any 302s
    // returned from the server. unfortunately 302s present as undefined error codes
    if ((error.status === undefined || error.status === 406) && store.state.config.useSAML) {
      window.location.reload()
    }
    // TODO: CHANGE TO WHAT SERVER RETURNS
    if ((error.response.status === 401 || error.response.status === 406) && router.currentRoute.name === 'LoginSSO') {
      router.push('/login')
    }
    if (error.response.status === 401 && store.state.config.useSAML) {
      window.location.replace(store.state.config.baseUrl + '/error/401.html')
    }
    if ((error.response.status === 401 || error.response.status === 406) && store.state.profile.loggedIn) {
      if (store.state.config.useSAML || store.state.config.useSSO) {
        window.stop()
        server.removeAuthOnPage()
        window.location.replace(store.state.config.authUrlLogOut)
      } else if (error.config.actionData) {
        store.commit(SAVE_SESSION_EXPIRED_ACTION, error.config.actionData)
      }
      return Promise.reject(error)
    }

    // if 500 causes 'Access-Control-Allow-Origin'
    if (error.response === undefined) {
      messageBus.serverError(error)
      return Promise.reject(error)
    } else if (error.response.status === 403) {
      store.commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.FORBIDDEN_RESOURCE)
      store.commit(SET_INFORMATION_SNACKBAR_STATE, true)
      router.push('/dashboard')
    } else if ((error.response.status === 500) || (error.response.status === 400)) {
      if (error.response.data.errorType.startsWith('VALIDATION_EXEMPTION')) {
        // Do nothing
      } else {
        messageBus.serverError(error)
      }
      return Promise.reject(error)
    } else {
      return Promise.reject(error)
    }
  })

let languages
axios.get('/static/translations/languages.json')
  .then((res) => {
    languages = res.data
    Vue.i18n.set(languages[0].name)
    fetchLanguages(languages, store)
    fetchConfig(store)
  })
  .catch((error) => {
    console.error(error)
  })

Vue.i18n.fallback('default')
Vue.config.productionTip = false

let authKey = server.getAuthOnPage()
if (authKey) {
  store.commit(LOGGED_IN, authKey)
}

let fetchLanguages = (languages, store) => {
  for (let language of languages) {
    axios.get(`/static/translations/${language.name}.json`)
      .then((res) => {
        let languageData = res.data
        Vue.i18n.add(language.name, languageData)
        store.commit(ADD_LANGUAGE, language)
      })
      .catch((error) => {
        console.log(`Errored while trying to fetch language files for ${language.name}`)
        console.error(error)
      })
  }
}

let fetchConfig = async (store) => {
  let path = window.location.pathname
  axios.get('/static/config/config.json')
    .then(async (res) => {
      store.commit(CONFIG_FETCH_SUCCESS, res.data)
      Vue.use(Vuetify, {theme: res.data.theme})

      // Only load if logged in
      if (store.state.profile.loginToken) {
        store.dispatch(GET_DROPDOWN_VALUES)
        store.dispatch(FETCH_USER_ANNOUNCEMENTS)
        store.dispatch(GET_ENGAGEMENT_LAST_SUCCESSFUL)
      }
      if (store.state.config.useSAML) {
        try {
          let uri = `${store.state.config.baseUrl}:${store.state.config.port}/core/samllogin`
          let response = await axios.post(uri, {})
          if (response.headers.authorization) {
            store.commit(LOGGED_IN, response.headers.authorization)
            server.setAuthOnPage(response.headers.authorization)
            store.dispatch(APPLY_SESSION_EXPIRED_ACTIONS)
            store.dispatch(GET_TUTOR_BOOLEAN)
            store.dispatch(GET_CHART_LIMIT_BOOLEAN)
            store.dispatch(GET_DROPDOWN_VALUES)
            store.dispatch(FETCH_USER_ANNOUNCEMENTS)
            store.dispatch(GET_ENGAGEMENT_LAST_SUCCESSFUL)
            router.push(path)
          }
        } catch (err) {
          console.log(err + ' login failed')
        }
      }
      /* eslint-disable no-new */
      new Vue({
        el: '#app',
        store,
        router,
        render: h => h(App)
      })
    })
    .catch((error) => {
      store.commit(CONFIG_FETCH_FAILED, error)
    })
}



// WEBPACK FOOTER //
// ./src/main.js